import {ComponentProps, forwardRef} from 'react'
import * as S from './styles'
import {useLazyImgProps} from './useLazyImgProps'

type ImageProps = ComponentProps<typeof S.Image> & {
  fallback?: any
  src: string
}

const KeyedImage = forwardRef<HTMLImageElement, ImageProps>(
  ({fallback = null, ...props}, ref) => {
    // @ts-expect-error useLazyImgProps isn't ported yet
    const imgProps = useLazyImgProps({...props, ref}) as any
    return imgProps ? <S.Image {...imgProps} /> : fallback
  },
)

const _Image = forwardRef<HTMLImageElement, ImageProps>(
  ({src, ...props}, ref) => (
    <KeyedImage key={src} src={src} ref={ref as any} {...props} />
  ),
)

export const Image = Object.assign(_Image, {
  Caption: S.Caption,
})

export const StyledImage = S.Image // for nested styles
